import React from "react";
import { capitalize } from "@common/helpers/string";
import { FiltersTypes } from "@common/types/filters/general";
import { FilterLabel } from "./FilterLabel";

interface Props {
    filters: FiltersTypes;
}

export const TransactionStatusFilterLabel: React.FC<Props> = ({ filters }) => {
    const statuses = filters.statuses;
    const count = statuses?.length ?? 0;

    let labelText: string | undefined;

    if (count === 1) {
        labelText = capitalize(statuses![0]);
    } else if (count > 1) {
        labelText = `${count} statuses`;
    }

    return <FilterLabel label={labelText} />;
};
